import { BlogDataService } from 'src/app/data/repository/blog-repository/blog-data.service';
import { CalendarShared } from './../../general/shared/calendar-shared';
import { MealRatioArray } from './../../../core/model/object/diet-model';
import { CanvasService } from './../../../data/repository/blog-repository/canvas.service';
import { FoodLogModel } from './../../../core/model/object/foodlog-model';
import { WaterLogDataService } from './../../../data/repository/plan-repository/water-log-data.service';
import { PlanService } from './../../../data/repository/plan-repository/plan.service';
import { DateHelper } from './../../../utils/date-helper';
import { TitleValueMap } from './../../../core/model/object/blog-model';
import { TextHelper } from './../../../utils/text-helper';
import { ExitCreatePostPopupComponent } from './../exit-create-post-popup/exit-create-post-popup.component';
import { Subscription } from 'rxjs';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { BlogUserModel } from 'src/app/core/model/object/blog-user-model';
import { LoadingShared } from './../../general/shared/loading-shared';
import { BlogShared } from './../../general/shared/blog-shared';
import { SnackBarService } from './../../../data/repository/utils-repository/snack-bar.service';
import { BlogService } from 'src/app/data/repository/blog-repository/blog.service';
import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  HostListener,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import { ReportBottomsheetModel } from '../../general/report-bottomsheet/report-bottomsheet.component';
import { ImageCroppedEvent, ImageCropperComponent } from 'ngx-image-cropper';
import { SetUsernameBottomsheetComponent } from '../set-username-bottomsheet/set-username-bottomsheet.component';
import { BlogTagModel } from 'src/app/core/model/object/blog-model';
import { WeightLogDataService } from 'src/app/data/repository/plan-repository/weight-log-data.service';
import { CalorieCalculator } from 'src/app/utils/calorie-calculator';

@Component({
  selector: 'app-blog-creat-post',
  templateUrl: './blog-creat-post.component.html',
  styleUrls: ['./blog-creat-post.component.scss'],
})
export class BlogCreatPostComponent implements OnInit, OnDestroy {
  @Input() user: BlogUserModel;

  @ViewChild(ImageCropperComponent) imageCropper: ImageCropperComponent;

  text = '';

  isActive = true;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  imageChangedEvent2: any = '';
  croppedImage2: any = '';
  base64 = '';

  showAfterIcon = true;
  showbeforeIcon = true;

  showCropImage = false;
  showCropImage2 = false;
  showBottomsheet = false;
  bottomsheetData: ReportBottomsheetModel;

  textareaHeight = 80;

  dayOfWeek = 0;
  thisWeekCalorie: TitleValueMap[] = [];
  lastWeekCalorie: TitleValueMap[] = [];
  todayAndYesterdayMeals: TitleValueMap[] = [];
  waterlogsWeeks = [];
  waterlogsWeeksTitle = [];
  weightlogsWeeks = [];
  weightlogsWeeksTitle = [];
  Ratio: number = 1 / 1;

  showCalorieHolder = false;
  showCalorieImageHolder = false;
  showMealHolder = false;
  showMealImageHolder = false;
  showWaterHolder = false;
  showWaterImageHolder = false;
  showWeightHolder = false;
  showWeightImageHolder = false;
  showBeforeAfterHolder = false;
  showBeforeAfterImageHolder = false;

  isCalorieEmpty = true;
  isMealEmpty = true;
  isWaterEmpty = true;
  isWeightEmpty = true;

  calander = false;
  calendarType = null;
  beforeTime: string = null;
  afterTime: string = null;

  imageType = 0;
  selectedTitleValueMap: TitleValueMap;
  selectedMeal: FoodLogModel[];
  selectedImage = new Image();
  selectedType = '';

  afterImage: HTMLImageElement = new Image();
  beforeImage: HTMLImageElement = new Image();

  showTagView = false;
  showUserView = false;
  searchTagMode = false;
  searchUserMode = false;
  textLastLength = 0;
  searchedTags: Array<BlogTagModel> = [];
  searchedUsers: BlogUserModel[] = [];

  mealRatioArray: MealRatioArray[] = [];

  imageAspectRatio: string = 'OTHER';

  subscription1: Subscription;
  subscription2: Subscription;
  subscription3: Subscription;
  subscription4: Subscription;

  progress: number = null;

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }
  fileChangeEvent2(event: any): void {
    this.imageChangedEvent2 = event;
  }
  imageCropped2(event: ImageCroppedEvent) {
    this.croppedImage2 = event.base64;
  }
  imageLoaded() {
    // show cropper
  }
  cropperReady() {
    // this.showLoading = false;
    // cropper ready
  }
  loadImageFailed() {
    // this.showLoading = false;
    // show message
  }

  constructor(
    private blogService: BlogService,
    private snackBarService: SnackBarService,
    private blogShared: BlogShared,
    private loadingShared: LoadingShared,
    private matBottomSheet: MatBottomSheet,
    private dialog: MatDialog,
    private textHelper: TextHelper,
    private dateHelper: DateHelper,
    public planService: PlanService,
    private cdr: ChangeDetectorRef,
    private waterLogDataService: WaterLogDataService,
    private weightLogDataService: WeightLogDataService,
    private canvasService: CanvasService,
    public calorieCalculator: CalorieCalculator,
    private blogDataService: BlogDataService,
    private calendarShared: CalendarShared
  ) {
    this.dayOfWeek =
      (new Date().getDay() + 2) % 7 !== 0 ? (new Date().getDay() + 2) % 7 : 7;

    this.checkCalorie();
    this.prepareWaterLogs();
    this.prepareWeightLogs();

    this.subscription1 = this.blogShared.usernameChangeObs$.subscribe(
      (changed) => {
        if (changed) {
          this.user.userName = this.blogShared.newUsername;
        }
      }
    );
    this.subscription2 = this.blogShared.exitCreatePostObs$.subscribe(
      (exit) => {
        if (exit) {
          if (this.text !== '' || this.croppedImage !== '') {
            const dialogRef = this.dialog.open(ExitCreatePostPopupComponent, {
              width: '90%',
              panelClass: 'custom-dialog-container',
            });
          } else {
            this.blogShared.closeCreatePost();
          }
        }
      }
    );
    this.user = this.blogDataService.getUser();
    this.subscription3 = this.calendarShared.closeCalendarObs$.subscribe(
      (close) => {
        if (close) {
          if (this.calendarType === 'before') {
            this.beforeTime = this.dateHelper.getYearAndMonthAndDayPersian(
              this.calendarShared.selectedDate
            );
            this.canvasService.createBeforeAfterImage(
              null,
              null,
              this.beforeTime,
              this.afterTime
            );
          } else if (this.calendarType === 'after') {
            this.afterTime = this.dateHelper.getYearAndMonthAndDayPersian(
              this.calendarShared.selectedDate
            );
            this.canvasService.createBeforeAfterImage(
              null,
              null,
              this.beforeTime,
              this.afterTime
            );
          }
          this.calendarType = null;
          this.calander = false;
        }
      }
    );
    this.subscription4 = this.blogService.progress.subscribe((p) => {
      this.progress = p;
    });
  }

  ngOnInit() {}

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
    this.subscription3.unsubscribe();
    this.subscription4.unsubscribe();
  }

  async createPost() {
    if (this.croppedImage === '' && this.text === '') {
      this.snackBarService.showSnackBar('محتویات پست خالی است');
      return;
    }
    if (this.checkUsername()) {
      console.log('here');

      this.loadingShared.showLoading();
      const result = await fetch(this.croppedImage);
      const blob = await result.blob();
      let payload = new FormData();
      payload.append('featuredImage', this.croppedImage === '' ? '-' : blob);
      payload.append('text', this.text);
      this.blogService
        .createPost(payload)
        .then((res) => {
          if (res.isSuccess()) {
            // this.blogShared.closeAndUpdateCreatePost();
            setTimeout(() => {
              this.progress = null;
            }, 5000);
            this.blogService.goback();
          } else {
            this.progress = null;
            this.snackBarService.showSnackBar(
              'مشکل در ارسال تصویر . دوباره تلاش کنید'
            );
          }
          this.loadingShared.hideLoading();
        })
        .catch(() => {
          this.progress = null;
          this.snackBarService.showSnackBar(
            'مشکل در ارسال تصویر . دوباره تلاش کنید'
          );
          this.loadingShared.hideLoading();
        });
    }
  }

  openCropImageView() {
    this.croppedImage = '';
    this.showCropImage = true;
    setTimeout(() => {
      document.getElementById('croppedImageView').style.right = '0';
    }, 100);
    setTimeout(() => {
      this.runLoading();
    }, 300);
  }

  closeCropImage() {
    this.croppedImage = '';
    this.imageChangedEvent = '';
    document.getElementById('croppedImageView').style.right = '100%';
    setTimeout(() => {
      this.showCropImage = false;
    }, 300);
  }
  closeCreatePostButton() {
    this.blogService.goback();
  }
  openCropImageView2() {
    this.croppedImage2 = '';
    this.showCropImage2 = true;
    setTimeout(() => {
      document.getElementById('croppedImageView2').style.right = '0';
    }, 100);
    setTimeout(() => {
      this.runLoading();
    }, 300);
  }

  closeCropImage2() {
    this.croppedImage2 = '';
    this.imageChangedEvent2 = '';
    document.getElementById('croppedImageView2').style.right = '100%';
    setTimeout(() => {
      this.showCropImage2 = false;
    }, 300);
  }

  openCalorie() {
    this.showCalorieHolder = true;
    setTimeout(() => {
      document.getElementById('calorieHolder').style.right = '0';
    }, 100);
  }

  closeCalorie() {
    document.getElementById('calorieHolder').style.right = '100%';
    setTimeout(() => {
      this.showCalorieHolder = false;
    }, 300);
  }

  openCalorieImage(titleValueMap: TitleValueMap) {
    this.showCalorieImageHolder = true;
    this.selectedTitleValueMap = titleValueMap;
    this.imageType = 0;
    this.selectedType = 'calorie';
    setTimeout(() => {
      this.createCalorieImage();
      document.getElementById('calorieImageHolder').style.right = '0';
    }, 100);
  }

  closeCalorieImage() {
    document.getElementById('calorieImageHolder').style.right = '100%';
    setTimeout(() => {
      this.showCalorieImageHolder = false;
    }, 300);
  }

  openMeal() {
    this.showMealHolder = true;
    setTimeout(() => {
      document.getElementById('mealHolder').style.right = '0';
    }, 100);
  }

  closeMeal() {
    document.getElementById('mealHolder').style.right = '100%';
    setTimeout(() => {
      this.showMealHolder = false;
    }, 300);
  }

  openMealImage(titleValueMap: TitleValueMap, meal: FoodLogModel[]) {
    this.showMealImageHolder = true;
    this.selectedTitleValueMap = titleValueMap;
    this.selectedMeal = meal;
    this.imageType = 0;
    this.selectedType = 'meal';
    setTimeout(() => {
      this.createMealDetailImage();
      document.getElementById('mealImageHolder').style.right = '0';
    }, 100);
  }

  closeMealImage() {
    document.getElementById('mealImageHolder').style.right = '100%';
    setTimeout(() => {
      this.showMealImageHolder = false;
    }, 300);
  }

  openWater() {
    this.showWaterHolder = true;
    setTimeout(() => {
      document.getElementById('waterHolder').style.right = '0';
    }, 100);
  }
  openBeforeAfter() {
    this.showBeforeAfterHolder = true;
    this.Ratio = 3 / 6;
    this.afterTime = this.dateHelper.getYearAndMonthAndDayPersian(new Date());
    setTimeout(() => {
      document.getElementById('beforeAfterImageHolder').style.right = '0';
      // this.openCropImageView2();
      this.canvasService.createClearBeforeAfter();
    }, 100);
  }
  beforeTheme(img: HTMLImageElement) {
    this.afterTime = this.dateHelper.getYearAndMonthAndDayPersian(new Date());
    this.canvasService.createBeforeAfterImage(
      img,
      null,
      this.beforeTime,
      this.afterTime
    );
  }
  AfterTheme(img: HTMLImageElement) {
    this.canvasService.createBeforeAfterImage(
      null,
      img,
      this.beforeTime,
      this.afterTime
    );
  }

  closeBeforeAfter() {
    this.Ratio = 1 / 1;

    document.getElementById('beforeAfterImageHolder').style.right = '100%';
    setTimeout(() => {
      this.afterImage = new Image();
      this.beforeImage = new Image();
      this.beforeTime = null;
      this.afterTime = null;
      this.showBeforeAfterHolder = false;
    }, 300);
  }
  closeWater() {
    document.getElementById('waterHolder').style.right = '100%';
    setTimeout(() => {
      this.showWaterHolder = false;
    }, 300);
  }

  openWaterImage(titleValueMap: TitleValueMap) {
    this.showWaterImageHolder = true;
    this.selectedTitleValueMap = titleValueMap;
    this.imageType = 0;
    this.selectedType = 'water';
    setTimeout(() => {
      this.createWaterDetailImage();
      document.getElementById('waterImageHolder').style.right = '0';
    }, 100);
  }

  closeWaterImage() {
    document.getElementById('waterImageHolder').style.right = '100%';
    setTimeout(() => {
      this.showWaterImageHolder = false;
    }, 300);
  }

  openWeight() {
    this.showWeightHolder = true;
    setTimeout(() => {
      document.getElementById('weightHolder').style.right = '0';
    }, 100);
  }

  closeWeight() {
    document.getElementById('weightHolder').style.right = '100%';
    setTimeout(() => {
      this.showWeightHolder = false;
    }, 300);
  }

  openWeightImage(titleValueMap: TitleValueMap) {
    this.showWeightImageHolder = true;
    this.selectedTitleValueMap = titleValueMap;
    this.imageType = 0;
    this.selectedType = 'weight';
    setTimeout(() => {
      this.createWeightDetailImage();
      document.getElementById('weightImageHolder').style.right = '0';
    }, 100);
  }

  closeWeightImage() {
    document.getElementById('weightImageHolder').style.right = '100%';
    setTimeout(() => {
      this.showWeightImageHolder = false;
    }, 300);
  }

  createCalorieImage() {
    this.imageType = 0;
    const dateLabel = this.dateHelper.getYearAndMonthAndDayPersian(
      this.selectedTitleValueMap.date
    );
    this.canvasService.createCalorieImage(
      dateLabel,
      this.selectedTitleValueMap.value
    );
  }

  createCalorieDetailImage() {
    this.imageType = 1;
    const dateLabel = this.dateHelper.getYearAndMonthAndDayPersian(
      this.selectedTitleValueMap.date
    );
    let mealNames = [];
    let meals = [];
    if (this.mealRatioArray.length === 0) {
      meals = ['breakfast', 'snack1', 'lunch', 'snack2', 'dinner', 'snack3'];
      meals.forEach((meal, i) => {
        mealNames[i] = this.findMealPersianName(meal);
      });
    } else {
      this.mealRatioArray[0].mealRatios.forEach((mr, i) => {
        meals[i] = mr.meal;
        mealNames[i] = mr.meal_text;
      });
    }
    this.canvasService.createCalorieDetailImage(
      dateLabel,
      this.selectedTitleValueMap.value,
      this.selectedTitleValueMap.foodLogs,
      meals,
      mealNames
    );
  }

  createMealDetailImage() {
    this.imageType = 0;
    const dateLabel = this.dateHelper.getYearAndMonthAndDayPersian(
      this.selectedTitleValueMap.date
    );
    this.selectedMeal.map((d, i) => {
      if (!d.foodModel.name && d.title) {
        this.selectedMeal[i].foodModel.name = d.title;
      }
    });

    this.canvasService.createMealDetailImage(
      dateLabel,
      this.selectedMeal,
      this.findMealPersianName(this.selectedMeal[0].meal)
    );
  }

  createMealImage() {
    this.imageType = 1;
    const dateLabel = this.dateHelper.getYearAndMonthAndDayPersian(
      this.selectedTitleValueMap.date
    );
    this.canvasService.createMealImage(
      dateLabel,
      this.selectedMeal,
      this.selectedImage,
      this.findMealPersianName(this.selectedMeal[0].meal)
    );
  }

  createWaterDetailImage() {
    this.imageType = 0;
    const dateLabel = this.dateHelper.getYearAndMonthAndDayPersian(
      this.selectedTitleValueMap.date
    );
    this.canvasService.createWaterDetailImage(
      dateLabel,
      this.selectedTitleValueMap.value
    );
  }

  createWaterImage() {
    this.imageType = 1;
    const dateLabel = this.dateHelper.getYearAndMonthAndDayPersian(
      this.selectedTitleValueMap.date
    );
    this.canvasService.createWaterImage(
      dateLabel,
      this.selectedTitleValueMap.value,
      this.selectedImage
    );
  }

  createWeightDetailImage() {
    this.imageType = 0;
    const dateLabel = this.dateHelper.getYearAndMonthAndDayPersian(
      this.selectedTitleValueMap.date
    );
    this.canvasService.createWeightDetailImage(
      dateLabel,
      this.selectedTitleValueMap.value
    );
  }

  createWeightImage() {
    this.imageType = 1;
    const dateLabel = this.dateHelper.getYearAndMonthAndDayPersian(
      this.selectedTitleValueMap.date
    );
    this.canvasService.createWeightImage(
      dateLabel,
      this.selectedTitleValueMap.value,
      this.selectedImage
    );
  }

  async checkCalorie(): Promise<boolean> {
    this.mealRatioArray = await this.planService.getDietRatioArray();

    let date = new Date(new Date().setHours(0, 0, 1, 0));
    for (let i = 0; i < 14; i++) {
      const dayDiff = Math.floor(
        (new Date().getTime() - date.getTime()) / (1000 * 60 * 60 * 24)
      );
      if (dayDiff < this.dayOfWeek && dayDiff >= 0) {
        const foodlogs = await this.planService.getThisDayFoodLogs(
          date.getTime(),
          false,
          false
        );
        let dayHasConsumedMeal = false;
        let calorie = 0;
        foodlogs.forEach((foodlog) => {
          dayHasConsumedMeal = true;
          calorie += this.calorieCalculator.calculateFoodLogCalorie(foodlog);
        });
        if (dayHasConsumedMeal) {
          this.isCalorieEmpty = false;
          const label =
            this.dateHelper.getTodayYesterdayTomorrowOrMonthAndDay(date);
          this.thisWeekCalorie.push(
            new TitleValueMap(
              label,
              calorie.toFixed(0) + ' کالری',
              date,
              foodlogs,
              null,
              null
            )
          );
          if (label === 'امروز' || label === 'دیروز') {
            this.isMealEmpty = false;
            const meals = [
              'breakfast',
              'snack1',
              'lunch',
              'snack2',
              'dinner',
              'snack3',
            ];
            const arrayOfFoodLogs: Array<FoodLogModel[]> = [];
            meals.forEach((meal) => {
              const mealFoodLogs = foodlogs.filter((obj) => obj.meal === meal);
              if (mealFoodLogs) {
                arrayOfFoodLogs.push(mealFoodLogs);
              }
            });
            this.todayAndYesterdayMeals.push(
              new TitleValueMap(
                label,
                calorie.toFixed(0) + ' کالری',
                date,
                foodlogs,
                null,
                null,
                arrayOfFoodLogs
              )
            );
          }
        }
      } else if (dayDiff < this.dayOfWeek + 7 && dayDiff >= 0) {
        const foodlogs = await this.planService.getThisDayFoodLogs(
          date.getTime(),
          false,
          false
        );
        let dayHasConsumedMeal = false;
        let calorie = 0;
        foodlogs.forEach((foodlog) => {
          dayHasConsumedMeal = true;
          calorie += this.calorieCalculator.calculateFoodLogCalorie(foodlog);
        });
        if (dayHasConsumedMeal) {
          this.isCalorieEmpty = false;
          const label =
            this.dateHelper.getTodayYesterdayTomorrowOrMonthAndDay(date);
          this.lastWeekCalorie.push(
            new TitleValueMap(
              label,
              calorie.toFixed(0) + ' کالری',
              date,
              foodlogs,
              null,
              null
            )
          );
          if (label === 'امروز' || label === 'دیروز') {
            this.isMealEmpty = false;
            let meals = [];
            if (this.mealRatioArray.length === 0) {
              meals = [
                'breakfast',
                'snack1',
                'lunch',
                'snack2',
                'dinner',
                'snack3',
              ];
            } else {
              this.mealRatioArray[0].mealRatios.forEach((mr, j) => {
                meals[j] = mr.meal;
              });
            }
            const arrayOfFoodLogs: Array<FoodLogModel[]> = [];
            meals.forEach((meal) => {
              const mealFoodLogs = foodlogs.filter((obj) => obj.meal === meal);
              if (mealFoodLogs) {
                arrayOfFoodLogs.push(mealFoodLogs);
              }
            });
            this.todayAndYesterdayMeals.push(
              new TitleValueMap(
                label,
                calorie.toFixed(0) + ' کالری',
                date,
                foodlogs,
                null,
                null,
                arrayOfFoodLogs
              )
            );
          }
        }
      }
      const d = date.getTime() - 1000 * 60 * 60 * 24;
      date = new Date(d);
    }
    // console.log(this.thisWeekCalorie, this.lastWeekCalorie)
    return Promise.resolve(true);
  }

  async prepareWaterLogs() {
    let startDate = new Date();
    startDate = new Date(startDate.setDate(startDate.getDate() + 1));
    startDate = new Date(startDate.setHours(0, 0, 0, 0));
    let endDate = new Date();
    endDate = new Date(
      endDate.setDate(endDate.getDate() - 21 - this.dayOfWeek)
    );
    endDate = new Date(endDate.setHours(0, 0, 0, 0));
    const wls = await this.waterLogDataService.getCustomWaterLogs(
      startDate.getTime(),
      endDate.getTime()
    );
    wls.waterlogs.forEach((wl) => {
      const dayDiff = Math.floor(
        (new Date().getTime() - wl.date) / (1000 * 60 * 60 * 24)
      );
      const label = this.dateHelper.getTodayYesterdayTomorrowOrMonthAndDay(
        new Date(wl.date)
      );
      if (wl.amount !== 0) {
        for (let i = 0; i < 4; i++) {
          if (dayDiff < this.dayOfWeek + i * 7) {
            if (!this.waterlogsWeeks[i]) {
              this.waterlogsWeeks[i] = [];
            }
            this.isWaterEmpty = false;
            this.waterlogsWeeks[i].push(
              new TitleValueMap(
                label,
                wl.amount + ' لیوان',
                new Date(wl.date),
                null,
                wl,
                null
              )
            );
            if (i === 0) {
              this.waterlogsWeeksTitle[0] = 'این هفته';
            } else if (i === 1) {
              this.waterlogsWeeksTitle[1] = 'هفته گذشته';
            } else {
              const date1 = new Date(
                new Date().setDate(
                  new Date().getDate() - (i * 7 - 1 + this.dayOfWeek)
                )
              );
              const date2 = new Date(
                new Date().setDate(
                  new Date().getDate() - ((i - 1) * 7 + this.dayOfWeek)
                )
              );
              this.waterlogsWeeksTitle[i] =
                this.dateHelper.getMonthAndDayPersianForTwoDates(date1, date2);
            }
            break;
          }
        }
      }
    });
    this.waterlogsWeeks.forEach((week) => {
      week.reverse();
    });
    // console.log('weightlogs', this.waterlogsWeeks, this.waterlogsWeeksTitle, this.dayOfWeek)
  }

  async prepareWeightLogs() {
    let startDate = new Date();
    startDate = new Date(startDate.setDate(startDate.getDate() + 1));
    startDate = new Date(startDate.setHours(0, 0, 0, 0));
    let endDate = new Date();
    endDate = new Date(endDate.setDate(endDate.getDate() - 99));
    endDate = new Date(endDate.setHours(0, 0, 0, 0));
    const wls = await this.weightLogDataService.getCustomWeightLogs(
      startDate.getTime(),
      endDate.getTime()
    );
    wls.weightlogs.forEach((wl) => {
      const dayDiff = Math.floor(
        (new Date().getTime() - wl.date) / (1000 * 60 * 60 * 24)
      );
      const label = this.dateHelper.getTodayYesterdayTomorrowOrMonthAndDay(
        new Date(wl.date)
      );
      for (let i = 0; i < 15; i++) {
        if (dayDiff < this.dayOfWeek + i * 7) {
          if (!this.weightlogsWeeks[i]) {
            this.weightlogsWeeks[i] = [];
          }
          this.isWeightEmpty = false;
          this.weightlogsWeeks[i].push(
            new TitleValueMap(
              label,
              wl.weight + ' کیلوگرم',
              new Date(wl.date),
              null,
              null,
              wl
            )
          );
          if (i === 0) {
            this.weightlogsWeeksTitle[0] = 'این هفته';
          } else if (i === 1) {
            this.weightlogsWeeksTitle[1] = 'هفته گذشته';
          } else {
            const date1 = new Date(
              new Date().setDate(
                new Date().getDate() - (i * 7 - 1 + this.dayOfWeek)
              )
            );
            const date2 = new Date(
              new Date().setDate(
                new Date().getDate() - ((i - 1) * 7 + this.dayOfWeek)
              )
            );
            this.weightlogsWeeksTitle[i] =
              this.dateHelper.getMonthAndDayPersianForTwoDates(date1, date2);
          }
          break;
        }
      }
    });
    this.weightlogsWeeks.forEach((week) => {
      week.reverse();
    });
    // console.log('weightlogs', this.weightlogsWeeks, this.weightlogsWeeksTitle)
  }

  rotateLeft() {
    this.imageCropper.rotateLeft();
  }

  runLoading() {
    document.getElementById('file').click();
    // this.showLoading = true;
  }
  getAfter() {
    this.selectedType = 'after';
    this.openCropImageView2();
  }
  getBefore() {
    this.selectedType = 'before';
    this.openCropImageView2();
  }
  setBeforeDate() {
    this.calander = true;
    this.calendarType = 'before';
  }
  setAfterDate() {
    this.calander = true;
    this.calendarType = 'after';
  }
  setPostImage() {
    this.imageChangedEvent = '';
    document.getElementById('croppedImageView').style.right = '100%';
    setTimeout(() => {
      this.showCropImage = false;
    }, 300);
  }

  setPostImage2() {
    if (
      this.selectedType == 'after' ||
      this.selectedType == 'before' ||
      this.showBeforeAfterHolder
    ) {
      if (
        this.afterImage.src == null ||
        this.afterImage.src == null ||
        this.afterTime == null ||
        this.beforeTime == null
      ) {
        this.snackBarService.showSnackBar('محتویات پست خالی است');
        return;
      } else {
        this.canvasService.createBeforeAfterImage(
          this.beforeImage,
          this.afterImage,
          this.beforeTime,
          this.afterTime
        );
        const canvas = document.getElementById(
          'canvasCreateImage'
        ) as HTMLCanvasElement;
        this.croppedImage = canvas.toDataURL('image/jpeg', 1.0);
        setTimeout(() => {
          this.cdr.detectChanges();
        }, 1000);
      }
    }

    if (this.selectedType === 'calorie') {
      this.closeCalorie();
      this.closeCalorieImage();
    }
    if (this.selectedType === 'meal') {
      this.closeMeal();
      this.closeMealImage();
    }
    if (this.selectedType === 'water') {
      this.closeWater();
      this.closeWaterImage();
    }
    if (this.selectedType === 'weight') {
      this.closeWeight();
      this.closeWeightImage();
    }
    if (this.selectedType == 'after' || this.selectedType == 'before') {
      this.closeBeforeAfter();
    }
  }

  setImageForEditing() {
    this.imageChangedEvent2 = '';
    document.getElementById('croppedImageView2').style.right = '100%';
    setTimeout(() => {
      this.showCropImage2 = false;
      this.selectedImage.src = this.croppedImage2;
      if (this.selectedType === 'meal') {
        this.createMealImage();
      }
      if (this.selectedType === 'water') {
        this.createWaterImage();
      }
      if (this.selectedType === 'weight') {
        this.createWeightImage();
      }
      if (this.selectedType === 'weight') {
      }
      if (this.selectedType === 'after') {
        this.showAfterIcon = false;
        this.afterImage.src = this.croppedImage2;
        // this.AfterTheme(this.selectedImage);
      }
      if (this.selectedType === 'before') {
        this.showbeforeIcon = false;
        this.beforeImage.src = this.croppedImage2;

        // this.beforeTheme(this.selectedImage);
      }
    }, 300);
  }

  removeImage() {
    this.croppedImage = '';
  }

  search() {
    if (this.text.charAt(this.text.length - 1) === '#') {
      this.searchTagMode = true;
      this.textLastLength = this.text.length;
    } else if (this.text.charAt(this.text.length - 1) === '@') {
      this.searchUserMode = true;
      this.textLastLength = this.text.length;
    } else if (this.text.charAt(this.text.length - 1) === ' ') {
      this.searchTagMode = false;
      this.showTagView = false;
    }
    if (this.searchTagMode) {
      if (this.textLastLength > this.text.length) {
        this.searchTagMode = false;
        this.showTagView = false;
      } else if (this.textLastLength === this.text.length) {
        this.searchTagMode = true;
        this.showTagView = false;
      } else {
        this.showTagView = true;
        setTimeout(() => {
          document.getElementById('tagView').style.height =
            (window.innerHeight - this.textareaHeight - 88).toString() + 'px';
        }, 10);
        this.loadingShared.showLoading();
        const text = this.text.slice(this.textLastLength, this.text.length);
        this.blogService
          .searchTag(
            this.textHelper.replaceArabicLettersWithPersian(
              this.text.slice(this.textLastLength, this.text.length)
            )
          )
          .then((res) => {
            if (res.isSuccess()) {
              if (
                text === this.text.slice(this.textLastLength, this.text.length)
              ) {
                this.searchedTags = res.getData().getBlogTagArray();
              }
            } else {
              this.searchedTags = [];
            }
            this.loadingShared.hideLoading();
          });
      }
    } else if (this.searchUserMode) {
      if (this.textLastLength > this.text.length) {
        this.searchUserMode = false;
        this.showUserView = false;
      } else if (this.textLastLength === this.text.length) {
        this.searchUserMode = true;
        this.showUserView = false;
      } else {
        this.showUserView = true;
        setTimeout(() => {
          document.getElementById('userView').style.height =
            (window.innerHeight - this.textareaHeight - 88).toString() + 'px';
        }, 10);
        this.loadingShared.showLoading();
        const text = this.text.slice(this.textLastLength, this.text.length);
        this.blogService
          .searchUser(
            this.textHelper.replaceArabicLettersWithPersian(
              this.text.slice(this.textLastLength, this.text.length)
            )
          )
          .then((res) => {
            if (res.isSuccess()) {
              if (
                text === this.text.slice(this.textLastLength, this.text.length)
              ) {
                this.searchedUsers = res.getData().getBlogUsers();
              }
            } else {
              this.searchedUsers = [];
            }
            this.loadingShared.hideLoading();
          });
      }
    }
  }

  replaceTagInSearch(tag: BlogTagModel) {
    this.text = this.text.slice(0, this.textLastLength) + tag.title + ' ';
    this.searchTagMode = false;
    this.showTagView = false;
    document.getElementById('postTextarea').focus();
  }

  replaceUsernameInSearch(username: string) {
    this.text = this.text.slice(0, this.textLastLength) + username + ' ';
    this.searchUserMode = false;
    this.showUserView = false;
    document.getElementById('postTextarea').focus();
  }

  autoGrow() {
    document.getElementById('postTextarea').style.height = '80px';
    document.getElementById('postTextarea').style.height =
      document.getElementById('postTextarea').scrollHeight - 32 + 'px';
    this.textareaHeight =
      document.getElementById('postTextarea').scrollHeight - 32;
  }

  checkUsername(): boolean {
    if (this.user?.userName === '') {
      this.matBottomSheet.open(SetUsernameBottomsheetComponent, {
        panelClass: 'custom-bottomsheet-container',
      });
      return false;
    }
    return true;
  }

  findMealPersianName(mealName: string): string {
    if (this.mealRatioArray.length !== 0) {
      const ans = this.mealRatioArray[0].mealRatios.find(
        ({ meal }) => meal === mealName
      );
      if (ans) {
        return ans.meal_text;
      } else {
        return this.planService.getMealPersianName(mealName);
      }
    } else {
      return this.planService.getMealPersianName(mealName);
    }
  }
}
